export default function cutString(string, maxSize) {
    return string.length > maxSize ? string.slice(0, maxSize) + '...' : string;
}